export enum textAriasMaxLength {
  BASE = 255,
  EXTENDED = 5000,
  RECORD_COMMENT = 5200,
}
